import ArchitectureFlowDialog from '@/components/landing/ArchitectureFlowDialog';

export default function ArchitecturePreviewCard() {
  return (
    <ArchitectureFlowDialog>
      <button
        type="button"
        className="group block w-full overflow-hidden rounded-2xl border border-border/60 bg-background/80 text-left transition-colors hover:border-primary/40 hover:bg-primary/5"
        aria-label="Open MapleOS architecture diagram"
      >
        <div className="border-b border-border/60 px-4 py-3 sm:px-5">
          <p className="text-sm font-semibold text-foreground">Understand the MapleOS architecture</p>
          <p className="mt-1 text-sm text-muted-foreground">
            Click the diagram to open the full interactive architecture view.
          </p>
        </div>

        <div className="relative aspect-[16/9] overflow-hidden bg-black">
          <img
            src="/images/mapleos/mapleos-architecture-diagram-2026-04-02.png"
            alt="MapleOS overview architecture diagram"
            className="h-full w-full object-cover object-left-top transition-transform duration-300 group-hover:scale-[1.02]"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" />
          <div className="absolute bottom-4 left-4 rounded-full border border-white/20 bg-black/60 px-3 py-1 text-xs font-medium text-white backdrop-blur-sm">
            Click to expand
          </div>
        </div>
      </button>
    </ArchitectureFlowDialog>
  );
}
